import '../css/style.scss';

import objectFitImages from '../../../dev/node_modules/object-fit-images';
objectFitImages('img.js-objectfit');
import barba from '../../../dev/node_modules/@barba/core';
import lottie from '../../../dev/node_modules/lottie-web';
import _ from '../../../dev/node_modules/lodash';
// =============================
// ユーザーエージェント判定
// =============================
var isPC = true;
var UA = navigator.userAgent.toLowerCase();
if(UA.indexOf('iphone') != -1 || UA.indexOf('ipad') != -1 || UA.indexOf('android') != -1){
	isPC = false;
}else{
	document.body.classList.add('js_hover');
	if(UA.indexOf('msie') != -1 || UA.indexOf('rv:11.0') != -1){
		// IEの時
		document.body.classList.add('__isIE');
	}
}

// スマホハンバーガーメニュー, gNavカレント判定,スクロール判定
var header = new Vue({
	el: '#header',
	data: {
		is_open: false,
		isCurrent: 'top',
		scrollY: 0
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeDestroy(){
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		handleScroll(){
			this.scrollY = window.scrollY;
		}
	},
	watch: {
		is_open: function(val) {
			if(val){
				document.body.classList.add('__fixed');
			}else{
				document.body.classList.remove('__fixed');
			}
		}
	}
});
var PagetopBtn = document.getElementById('btnPagetop');
PagetopBtn.addEventListener('click', () => {
	window.scroll({
		top: 0,
		behavior: 'smooth'
	})
});
// tophアニメ
let lottieObj = lottie.loadAnimation({
  container: document.getElementById('toph'), // 表示させたい要素を渡します
  renderer: 'svg', // 描画形式を指定します. // svg or canvas or html svg以外ちゃんとためしてないですが
  loop: true, // trueにしたらループです。1回再生の場合はfalseで
  autoplay: true, // 自動再生です。falseの場合は自分のタイミングで
  // path: '/_theme/blog_static/common/js/data_toph.json' // 再生させたいアニメーションのjsonのパスを指定します。
  path: '/common/js/data_toph.json' // 再生させたいアニメーションのjsonのパスを指定します。
});
function tophAnim(){
	let num = 0;
	lottieObj.playSegments([0,180], true);
	lottieObj.onLoopComplete = function(){
		num++;
		if(num == 5){
			lottieObj.playSegments([181,199], true);
			lottieObj.onLoopComplete = function(){
				lottieObj.playSegments([200, 270], true);
			}
		}
	}
}
function tophWakeup(){
	lottieObj.playSegments([271, 300], true);
	lottieObj.onLoopComplete = function(){

		tophAnim();
	}
}
const wakeupTrigger = document.getElementById('wakeup_toph');
if(isPC){
	wakeupTrigger.addEventListener('mouseover', function(event){
		// setTimeout(function(){
			tophWakeup();
		// }, 100);
	}, false);
}else{
	wakeupTrigger.addEventListener('click', function(){
		tophWakeup();
	});
}
lottieObj.addEventListener('data_ready', function(){
tophAnim();
});
// pjaxで遷移後にhead内の任意のタグを書き換え
function replaceHeadTags(target){
	// head内のmetaタグなど置き換え
	var head = document.head;
	var headTags = [
		"meta[name='keywords']",
		"meta[name='description']",
		"meta[property^='og']",
		"meta[name^='twitter']",
		"meta[itemprop]",
		"link[itemprop]",
		"link[rel='prev']",
		"link[rel='next']",
		"link[rel='canonical']",
		"link[rel='alternate']"
	].join(',');
	var oldHeadTags = head.querySelectorAll( headTags );
	for ( var i = 0; i < oldHeadTags.length; i++ ){
		head.removeChild(oldHeadTags[i]);
	}
	var newPageRawHead = target.match( /<head[^>]*>([\s\S.]*)<\/head>/i )[ 0 ],
		newPageHead = document.createElement( 'head' );
		
	newPageHead.innerHTML = newPageRawHead;
	var newHeadTags = newPageHead.querySelectorAll( headTags );
    for ( var i = 0; i < newHeadTags.length; i++ ) {
        head.appendChild( newHeadTags[ i ] );
    }
}
barba.init({
	transitions: [
		{
			name: 'custom-transition',
			leave({ current, next, trigger}){
				return new Promise(resolve => {
					// ハンバーガーメニューを閉じる
					header.is_open=false;
					document.body.classList.add('js_isLeaving');
					lottieObj.playSegments([272, 300],true);
					lottieObj.onLoopComplete = function(){
						lottieObj.pause();
					}
					setTimeout(function(){
						resolve();
					}, 500);
				});
			},
			enter({ current, next, trigger}){
				replaceHeadTags(next.html);

				window.scrollTo(0, 0);
				setTimeout(function(){
					lottieObj.playSegments([302,326], true);
					lottieObj.onLoopComplete = function(){
						tophAnim();
					}
				}, 250);
				setTimeout(function(){
					document.body.classList.remove('js_isLeaving');
				}, 500);
			},
			after({next}){
				var hash = next.url.hash;
				if(hash){
					setTimeout(function(){
						var target = document.getElementById(hash);
						var top = target.getBoundingClientRect().top;
						window.scrollTo(0, top);
					},500);
				}
			}
		}
	],
	views: [{
		namespace: 'lower',
		afterLeave(data){
			header.isCurrent = 'none';
		},
		afterEnter(data){
			var next = data['next']['namespace'],
				next_url = data['next']['url']['path'];
			header.isCurrent = next_url;
			
		}
	}, {
		namespace: 'top',
		afterLeave(data){
			var next = data['next']['namespace'],
				next_url = data['next']['url']['path'];
			header.isCurrent = next_url;
			if(next == 'lower'){
				// TOPから下層への遷移
				document.body.classList.remove('__top');
			}
		},
		afterEnter(data){
			header.isCurrent = 'top';
			document.body.classList.add('__top');
		}
	}],
	prevent: ({ el }) => el.classList && el.classList.contains('__prevent')
});
const eventDelete = e => {
  if (e.currentTarget.href === window.location.href) {
    e.preventDefault()
    e.stopPropagation()
    return
  }
}

// barba.hooks.enter(() => {
//   window.scrollTo(0, 0);
// });
barba.hooks.after((data) => {
	// console.log(data);
	if(typeof gtag === 'function') {
		gtag('config', window.GA_MEASUREMENT_ID, {
			page_path: window.location.pathname
		});
	}
});

// フォームバリデーション
window.MTNetFormDataLayer = window.MTNetFormDataLayer || [];
function MTNetForm() { MTNetFormDataLayer.push(arguments); }
MTNetForm("validator", {
  validator: function(values) {
    var email, confirm, confirmId;
    values.forEach(function(v) {
      if (v.label === "メールアドレス") {
        email = v.value;
      } else if (v.label === "メールアドレス（確認）") {
        confirm = v.value;
        confirmId = v.id;
      }
    });

    if (email && confirm && email !== confirm) {
      return {
        id: confirmId,
        message: "「メールアドレス（確認）」が一致していません。",
      };
    }
  },
});